module.exports = __webpack_public_path__ + "static/media/gold_offer_myway3.6a0338b8.jpg";